// Code get from documents client gave
export const BEACON_ALERT_CODE = {
    1: 'messages.beacon_off',
    2: 'messages.beacon_recovery',
    3: 'messages.beacon_failure_position',
    4: 'messages.beacon_recovery_position'
}

export const LOCATION_ALERT_CODE = {
    1: 'messages.location_failure_gps',
    2: 'messages.location_position_gps'
}
